import React, { useEffect, useState } from 'react';

interface Score {
  name: string;
  score: number;
}

export default function Podium({ scores }: { scores: Score[] }) {
  const [show, setShow] = useState(false);
  useEffect(() => {
    const t = setTimeout(() => setShow(true), 50);
    return () => clearTimeout(t);
  }, []);

  const top = [...scores].slice(0, 3);
  while (top.length < 3) top.push({ name: '', score: 0 });
  const display = [top[1], top[0], top[2]]; // silver, gold, bronze
  const heights = ['h-24', 'h-32', 'h-20'];
  const colors = ['bg-gray-300', 'bg-yellow-300', 'bg-orange-300'];

  return (
    <div className="flex justify-center items-end space-x-4 mb-4">
      {display.map((s, i) => (
        <div key={i} className="flex flex-col items-center">
          <div
            className={
              `${heights[i]} w-20 ${colors[i]} rounded-t transition-transform duration-500` +
              (show ? ' scale-100' : ' scale-0')
            }
          >
            <div className="h-full flex items-end justify-center pb-1 font-bold">
              {s.score > 0 ? s.score : ''}
            </div>
          </div>
          <div className="mt-1 text-sm text-center w-20 truncate">{s.name}</div>
        </div>
      ))}
    </div>
  );
}

